export function isValidZip(zip: string) {
    return /^[0-9]{5}(?:-[0-9]{4})?$/.test(zip);
}

export function isValidPhoneWithExtension(phone: string) {
    return /^[2-9]\d{2}[. -]?[2-9]\d{2}[. -]?\d{4}/.test(phone);
}

export function formatPhoneNumber(number: string | nullish) {
    return number?.replace(/^1?(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
}

export function isValidPhoneNumber(number: string | nullish) {
    return number?.replace(/\D/g, '').length === 10;
}
